import React from 'react';
import { Icons } from '../../lib/Icons';

export default function CapabilityNotice({ title, body }) {
  return (
    <div className="rounded-xl border border-amber-200 bg-amber-50 p-4">
      <div className="flex items-start gap-3">
        <Icons.ExclamationTriangle className="mt-0.5 h-5 w-5 text-amber-600" />
        <div>
          <p className="text-sm font-semibold text-amber-900">{title}</p>
          <p className="mt-1 text-sm text-amber-800">{body}</p>
        </div>
      </div>
    </div>
  );
}
